<template>
  <div style="display: flex; flex-direction: column; gap: 20px; margin: 20px 0">
    <!-- 对照组 -->
    <div
      style="
        flex: 0 1 45%;
        box-sizing: border-box;
        border: 1px solid #e8eaec;
        padding: 20px;
        border-radius: 4px;
      "
    >
      <h3 style="margin-bottom: 20px">对照组</h3>
      <div style="display: flex; flex-direction: column; gap: 10px">
        <FormItem label="剧集收费：" :label-width="150">
          <Input
            :value="defaultGroup.episodeCharge.chargeCoins || '跟随剧集设置'"
            disabled
          />
        </FormItem>
        <FormItem label="广告解锁上限(人/日)：" :label-width="150">
          <Input
            :value="
              defaultGroup.dailyAdUnlockLimit.maxAdWatchCount || '加载中...'
            "
            disabled
          />
        </FormItem>
        <FormItem label="活动金币上限：" :label-width="150">
          <Input
            :value="defaultGroup.activityAdLimit.maxAdWatchCount || '加载中...'"
            disabled
          />
        </FormItem>
        <FormItem :label-width="150" label="iOS付费模板：">
          <div
            @click="defaultIosExpanded = !defaultIosExpanded"
            style="
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 10px;
            "
          >
            <span style="font-weight: bold">ios付费模板配置</span>
            <Icon
              type="ios-arrow-down"
              :class="{ 'rotate-180': defaultIosExpanded }"
              style="transition: transform 0.3s"
            ></Icon>
          </div>
          <div
            v-if="defaultIosExpanded"
            style="display: flex; flex-wrap: wrap; margin: 0 -5px"
          >
            <div
              style="padding: 5px; flex: 0 1 50%; width: 50%"
              v-for="(item, index) in defaultIosGoods.map((i) => i.goodsName)"
              :key="index"
            >
              <div
                style="
                  border: 1px solid #e8eaec;
                  padding: 5px;
                  border-radius: 5px;
                "
              >
                {{ item }}
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem :label-width="150" label="Android付费模板：">
          <!-- 展开/收起切换 -->

          <div
            @click="defaultAndroidExpanded = !defaultAndroidExpanded"
            style="
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 10px;
            "
          >
            <span style="font-weight: bold">android付费模板配置</span>
            <Icon
              type="ios-arrow-down"
              :class="{ 'rotate-180': defaultAndroidExpanded }"
              style="transition: transform 0.3s"
            ></Icon>
          </div>

          <!-- 付费模板内容（默认收起） -->

          <div
            v-if="defaultAndroidExpanded"
            style="display: flex; flex-wrap: wrap; margin: 0 -5px"
          >
            <div
              style="padding: 5px; flex: 0 1 50%; width: 50%"
              v-for="(item, index) in defaultAndroidGoods.map(
                (i) => i.goodsName
              )"
              :key="index"
            >
              <div
                style="
                  border: 1px solid #e8eaec;
                  padding: 5px;
                  border-radius: 5px;
                "
              >
                {{ item }}
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem :label-width="150">
          <!-- 展开/收起切换 -->

          <!-- 付费模板内容（默认收起） -->
        </FormItem>
      </div>
    </div>

    <!-- 实验组列表 -->
    <div
      v-for="i in Array.from(
        { length: experimentGroupCount },
        (_, index) => index + 1
      )"
      :key="i"
      style="
        flex: 0 0 45%;
        box-sizing: border-box;
        border: 1px solid #e8eaec;
        padding: 20px;
        border-radius: 4px;
      "
    >
      <h3 style="margin-bottom: 20px">实验组 {{ i }}</h3>
      <div style="display: flex; flex-direction: column; gap: 10px">
        <FormItem
          label="剧集收费："
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.episodeCharge.chargeCoins`"
          :label-width="150"
          :rules="[
            { required: true, message: '请输入剧集收费', trigger: ['blur'] }
          ]"
        >
          <div style="display: flex; align-items: center; gap: 10px">
            <Input
              :disabled="disabled"
              style="width: 100px"
              v-model="
                formData.groups[i - 1].experimentGroupParam.episodeCharge
                  .chargeCoins
              "
            />
            <span>金币/集</span>
          </div>
        </FormItem>
        <FormItem
          label="广告解锁上限(人/日)："
          :label-width="150"
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.dailyAdUnlockLimit.maxAdWatchCount`"
          :rules="[
            { required: true, message: '请输入广告解锁上限', trigger: ['blur'] }
          ]"
        >
          <div style="display: flex; align-items: center; gap: 10px">
            <Input
              :disabled="disabled"
              style="width: 100px"
              v-model="
                formData.groups[i - 1].experimentGroupParam.dailyAdUnlockLimit
                  .maxAdWatchCount
              "
            />
            <span>次</span>
          </div>
        </FormItem>
        <FormItem
          label="活动页看广告领金币上限(人/日)："
          :label-width="150"
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.activityAdLimit.maxAdWatchCount`"
          :rules="[
            {
              required: true,
              message: '请输入活动页看广告领金币上限',
              trigger: ['blur']
            }
          ]"
        >
          <div style="display: flex; align-items: center; gap: 10px">
            <Input
              :disabled="disabled"
              style="width: 100px"
              v-model="
                formData.groups[i - 1].experimentGroupParam.activityAdLimit
                  .maxAdWatchCount
              "
            />
            <span>次</span>
          </div>
        </FormItem>
        <!-- <div v-if="formData.countriesUnlimited"> -->
        <FormItem
          v-if="formData.deviceSys === '0' || formData.deviceSys === '-1'"
          label="iOS付费模板："
          :label-width="150"
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.paymentPanel.countryIosGoodsIds`"
        >
          <!-- 展开/收起切换 -->
          <div
            @click="
              $set(
                formData.groups[i - 1].experimentGroupParam,
                'iosExpanded',
                !formData.groups[i - 1].experimentGroupParam.iosExpanded
              )
            "
            style="
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 10px;
            "
          >
            <span style="font-weight: bold">iOS付费模板配置</span>
            <Icon
              type="ios-arrow-down"
              :class="{
                'rotate-180':
                  formData.groups[i - 1].experimentGroupParam.iosExpanded
              }"
              style="transition: transform 0.3s"
            ></Icon>
          </div>

          <!-- 付费模板内容（默认收起） -->
          <div v-show="formData.groups[i - 1].experimentGroupParam.iosExpanded">
            <!-- VIP付费项 -->
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 10px; font-weight: bold">
                会员付费项
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px">
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 1"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[0]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 2"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[1]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 3"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[2]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
              </div>
            </div>

            <!-- 金币付费项 -->
            <div>
              <div style="margin-bottom: 10px; font-weight: bold">
                金币付费项
              </div>
              <div
                class="gold-select-container"
                style="display: flex; flex-wrap: wrap"
              >
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[3]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[4]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[5]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[6]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[7]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryIosGoodsIds[8]
                  "
                >
                  <Option
                    v-for="(item, index) in iosGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem
          v-if="formData.deviceSys === '1' || formData.deviceSys === '-1'"
          label="Android付费模板："
          :label-width="150"
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.paymentPanel.countryAndroidGoodsIds`"
        >
          <!-- 展开/收起切换 -->
          <div
            @click="
              $set(
                formData.groups[i - 1].experimentGroupParam,
                'androidExpanded',
                !formData.groups[i - 1].experimentGroupParam.androidExpanded
              )
            "
            style="
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 10px;
            "
          >
            <span style="font-weight: bold">Android付费模板配置</span>
            <Icon
              type="ios-arrow-down"
              :class="{
                'rotate-180':
                  formData.groups[i - 1].experimentGroupParam.androidExpanded
              }"
              style="transition: transform 0.3s"
            ></Icon>
          </div>

          <!-- 付费模板内容（默认收起） -->
          <div
            v-show="formData.groups[i - 1].experimentGroupParam.androidExpanded"
          >
            <!-- VIP付费项 -->
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 10px; font-weight: bold">
                会员付费项
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px">
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 1"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[0]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 2"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[1]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 3"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[2]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
              </div>
            </div>

            <!-- 金币付费项 -->
            <div>
              <div style="margin-bottom: 10px; font-weight: bold">
                金币付费项
              </div>
              <div
                class="gold-select-container"
                style="display: flex; flex-wrap: wrap"
              >
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[3]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[4]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[5]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[6]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[7]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .countryAndroidGoodsIds[8]
                  "
                >
                  <Option
                    v-for="(item, index) in androidGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.countryAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
              </div>
            </div>
          </div>
        </FormItem>
        <!-- </div> -->
        <FormItem
          v-if="formData.deviceSys === '0' || formData.deviceSys === '-1'"
          label="iOS默认付费模板："
          :label-width="150"
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.paymentPanel.defaultIosGoodsIds`"
        >
          <!-- 展开/收起切换 -->
          <div
            @click="
              $set(
                formData.groups[i - 1].experimentGroupParam,
                'iosDefaultExpanded',
                !formData.groups[i - 1].experimentGroupParam.iosDefaultExpanded
              )
            "
            style="
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 10px;
            "
          >
            <span style="font-weight: bold">iOS付费模板配置</span>
            <Icon
              type="ios-arrow-down"
              :class="{
                'rotate-180':
                  formData.groups[i - 1].experimentGroupParam.iosDefaultExpanded
              }"
              style="transition: transform 0.3s"
            ></Icon>
          </div>

          <!-- 付费模板内容（默认收起） -->
          <div
            v-show="
              formData.groups[i - 1].experimentGroupParam.iosDefaultExpanded
            "
          >
            <!-- VIP付费项 -->
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 10px; font-weight: bold">
                会员付费项
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px">
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 1"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[0]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 2"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[1]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 3"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[2]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
              </div>
            </div>

            <!-- 金币付费项 -->
            <div>
              <div style="margin-bottom: 10px; font-weight: bold">
                金币付费项
              </div>
              <div
                class="gold-select-container"
                style="display: flex; flex-wrap: wrap"
              >
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[3]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[4]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[5]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[6]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[7]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultIosGoodsIds[8]
                  "
                >
                  <Option
                    v-for="(item, index) in iosDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultIosGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem
          v-if="formData.deviceSys === '1' || formData.deviceSys === '-1'"
          label="Android默认付费模板："
          :label-width="150"
          :prop="`groups[${
            i - 1
          }].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds`"
        >
          <!-- 展开/收起切换 -->
          <div
            @click="
              $set(
                formData.groups[i - 1].experimentGroupParam,
                'androidDefaultExpanded',
                !formData.groups[i - 1].experimentGroupParam
                  .androidDefaultExpanded
              )
            "
            style="
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 10px;
            "
          >
            <span style="font-weight: bold">Android付费模板配置</span>
            <Icon
              type="ios-arrow-down"
              :class="{
                'rotate-180':
                  formData.groups[i - 1].experimentGroupParam
                    .androidDefaultExpanded
              }"
              style="transition: transform 0.3s"
            ></Icon>
          </div>

          <!-- 付费模板内容（默认收起） -->
          <div
            v-show="
              formData.groups[i - 1].experimentGroupParam.androidDefaultExpanded
            "
          >
            <!-- VIP付费项 -->
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 10px; font-weight: bold">
                会员付费项
              </div>
              <div style="display: flex; flex-direction: column; gap: 10px">
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 1"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[0]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 2"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[1]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  placeholder="会员付费项 3"
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[2]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsVipList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{
                      item.goodsName
                    }})
                  </Option>
                </Select>
              </div>
            </div>

            <!-- 金币付费项 -->
            <div>
              <div style="margin-bottom: 10px; font-weight: bold">
                金币付费项
              </div>
              <div
                class="gold-select-container"
                style="display: flex; flex-wrap: wrap"
              >
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[3]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[4]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[5]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[6]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[7]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
                <Select
                  :disabled="disabled"
                  clearable
                  v-model="
                    formData.groups[i - 1].experimentGroupParam.paymentPanel
                      .defaultAndroidGoodsIds[8]
                  "
                >
                  <Option
                    v-for="(item, index) in androidDefaultGoodsGoldList"
                    :key="index"
                    :value="item.id"
                    :disabled="
                      formData.groups[
                        i - 1
                      ].experimentGroupParam.paymentPanel.defaultAndroidGoodsIds.includes(
                        item.id
                      )
                    "
                  >
                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{
                      item.goodsNum
                    }}({{ item.goodsName }})
                  </Option>
                </Select>
              </div>
            </div>
          </div>
        </FormItem>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsList, getBatch } from '@/api/goods'
import { getDefaultGroup } from '@/api/abtest'

export default {
  name: 'GroupConfig',
  props: {
    // 表单数据
    formData: {
      type: Object,
      required: true
    },
    // 实验组数量
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 对照组iOS付费模板展开状态
      defaultIosExpanded: false,
      // 对照组Android付费模板展开状态
      defaultAndroidExpanded: false,
      // 对照组数据
      defaultGroup: {
        episodeCharge: {
          chargeCoins: '',
          unlockLimit: '',
          mixInsertLimit: ''
        },
        activityAdLimit: {
          maxAdWatchCount: ''
        },
        dailyAdUnlockLimit: {
          maxAdWatchCount: ''
        },
        paymentPanel: {
          iosVipTemplateId: '',
          androidVipTemplateId: ''
        }
      },
      // 安卓商品付费项列表
      androidGoodsVipList: [],
      androidDefaultGoodsVipList: [],
      // 安卓商品金币项列表
      androidGoodsGoldList: [],
      androidDefaultGoodsGoldList: [],
      // 苹果商品付费项列表
      iosGoodsVipList: [],
      iosDefaultGoodsVipList: [],
      // 苹果商品金币项列表
      iosGoodsGoldList: [],
      iosDefaultGoodsGoldList: [],
      // 对照组商品列表
      defaultAndroidGoods: [],
      defaultIosGoods: []
    }
  },
  created() {
    this.handleGetGoods()
    this.handleGetDefaultGroup()
    
    // 初始化实验组数据
    if (!this.formData.groups) {
      this.$set(this.formData, 'groups', [])
    }
    const { groups } = this.formData
    const currentCount = groups.length
    if (currentCount < this.experimentGroupCount) {
      // 触发watch来初始化实验组
      this.$nextTick(() => {
        this.experimentGroupCount = this.experimentGroupCount
      })
    }
  },
  watch: {
    experimentGroupCount(newCount, oldCount) {
      if (!this.formData.groups) {
        this.$set(this.formData, 'groups', [])
      }
      const { groups } = this.formData
      const currentCount = groups.length
      
      // 如果新数量大于当前数量，添加新的实验组
      if (newCount > currentCount) {
        for (let i = currentCount; i < newCount; i++) {
          this.$set(this.formData.groups, i, {
            experimentGroupParam: {
              episodeCharge: {
                chargeCoins: ''
              },
              dailyAdUnlockLimit: {
                maxAdWatchCount: ''
              },
              activityAdLimit: {
                maxAdWatchCount: ''
              },
              paymentPanel: {
                countryIosGoodsIds: [],
                countryAndroidGoodsIds: [],
                defaultIosGoodsIds: [],
                defaultAndroidGoodsIds: []
              },
              iosExpanded: false,
              androidExpanded: false,
              iosDefaultExpanded: false,
              androidDefaultExpanded: false
            }
          })
        }
      } 
      // 如果新数量小于当前数量，删除多余的实验组
      else if (newCount < currentCount) {
        this.formData.groups.splice(newCount)
      }
    }
  },
  methods: {
    async handleGetGoodsBatch(ids) {
      const r = await getBatch({ ids })
      return r.data
    },
    async applyDefaultGroup(defaultParam) {
      const data = defaultParam || this.defaultGroup
      this.defaultGroup = data
      const iosList = Array.from(
        new Set(
          [
            ...(data.paymentPanel.countryIosGoodsIds || []),
            ...(data.paymentPanel.defaultIosGoodsIds || [])
          ].filter(Boolean)
        )
      )
      const androidList = Array.from(
        new Set(
          [
            ...(data.paymentPanel.countryAndroidGoodsIds || []),
            ...(data.paymentPanel.defaultAndroidGoodsIds || [])
          ].filter(Boolean)
        )
      )
      this.defaultAndroidGoods = androidList.length
        ? await this.handleGetGoodsBatch(androidList.join(','))
        : []
      this.defaultIosGoods = iosList.length
        ? await this.handleGetGoodsBatch(iosList.join(','))
        : []
    },
    async handleGetDefaultGroup() {
      const response = await getDefaultGroup({
        countries: this.formData.countries
          ? this.formData.countries.join(',')
          : '',
        playIds: this.formData.playIds ? this.formData.playIds.join(',') : ''
      })
      await this.applyDefaultGroup(response.data)
    },
    validate() {
      return true
    },
    handleGetGoods() {
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 0,
        goodsChannel: 1,
        countryCodeList: (this.formData.countries || []).join(','),
        worldWide: false
      }).then((r) => {
        this.androidGoodsGoldList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 1,
        goodsChannel: 1,
        countryCodeList: (this.formData.countries || []).join(','),
        worldWide: false
      }).then((r) => {
        this.androidGoodsVipList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 1,
        goodsChannel: 0,
        countryCodeList: (this.formData.countries || []).join(','),
        worldWide: false
      }).then((r) => {
        this.iosGoodsVipList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 0,
        goodsChannel: 0,
        countryCodeList: (this.formData.countries || []).join(','),
        worldWide: false
      }).then((r) => {
        this.iosGoodsGoldList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 0,
        goodsChannel: 1,
        worldWide: true
      }).then((r) => {
        this.androidDefaultGoodsGoldList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 1,
        goodsChannel: 1,
        worldWide: true
      }).then((r) => {
        this.androidDefaultGoodsVipList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 1,
        goodsChannel: 0,
        worldWide: true
      }).then((r) => {
        this.iosDefaultGoodsVipList = r.data.records
      })
      getGoodsList({
        current: -1,
        size: -1,
        goodsType: 0,
        goodsChannel: 0,
        worldWide: true
      }).then((r) => {
        this.iosDefaultGoodsGoldList = r.data.records
      })
    },
    // 刷新商品列表
    refreshGoods() {
      this.handleGetGoods()
    }
  }
}
</script>

<style scoped lang="less">
/* 旋转图标样式 */
.rotate-180 {
  transform: rotate(180deg);
}
.gold-select-container {
  margin: 0 -5px;
  & > * {
    padding: 5px;
    flex: 0 1 50%;
    box-sizing: border-box;
    width: 50%;
  }
}
</style>
